import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui-icons/Close';
import './Notification.css';
import addReadListImgSrc from '../../assets/images/components/notification_book_added.png';
import removeReadListImgSrc from '../../assets/images/components/notification_book_remove.gif';
import bookSavedImgSrc from '../../assets/images/components/notification_book_saved.png';
import addBookDecorationImgSrc from '../../assets/images/components/notification_addBook_decoration.png';

const verticalFlipStyle = {
    transform: 'scaleY(-1)',
    filter: 'FlipH',
    '-ms-filter': 'FlipH',
};

function BookChangeToast(props) {
    let imgSrc;
    if  (props.isAdd) {
        imgSrc = props.isReadLog ? addReadListImgSrc : bookSavedImgSrc;
    } else {
        imgSrc = props.isReadLog ? removeReadListImgSrc : bookSavedImgSrc;
    }

    const isRemoveSavedBook = !props.isAdd && !props.isReadLog;

    const toastMessage = (isAdd, isReadLog) => {
        if(isReadLog) {
            return isAdd?  'Book added to Reading Log' : 'Book removed from Reading Log'
        } else {
            return isAdd?  'Book Saved!' : 'Book removed from Saved Books'
        }
    }
    return (
        <Snackbar
            className="notification"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={props.isOpen}
            onClose={props.closeHandler}
            SnackbarContentProps={{'aria-describedby': 'notification_toast_message'}}
            autoHideDuration={4000}
            action={[
                <IconButton
                    className="notification__icon"
                    key="close"
                    color="inherit"
                    onClick={props.closeHandler}>
                    <CloseIcon />
                </IconButton>
            ]}
            message={
                <span
                    className="notification__message"
                    id="notification_toast_message">
                    <img className="notification__message--icon" src={imgSrc} width={50} height={63} alt=""
                        style={isRemoveSavedBook ? verticalFlipStyle : undefined} // flip vertical to make thumbs down
                    />
                    {props.isAdd && props.isReadLog? //show book mark img when add to reading log
                        <img src={addBookDecorationImgSrc}
                             className="notification__message--decoration"
                             width={58}
                             height={40}
                             alt=""/>
                        : ''}
                    <span role="status" aria-live="assertive">
                        {toastMessage(props.isAdd, props.isReadLog)}
                    </span>
                </span>
            }
        />
    );
}

export default BookChangeToast;
